import * as XLSX from 'xlsx/dist/xlsx.mini.min';
import { ColumnMapping } from '../components-openagri/agx-pivot-table/agx-pivot-table.component';

export abstract class ExcelHelper {
  static downloadPivotTableData(
    title: string,
    data: any[],
    selectedColumns: ColumnMapping[],
    aggregatedColumns: ColumnMapping[],
    includeRawData = false,
  ) {
    if (data.length === 0) {
      return null;
    }
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(
      this.dataToRows(data, selectedColumns, aggregatedColumns),
    );
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    if (includeRawData) this.addRawData(data, wb);

    XLSX.writeFile(wb, title + '-' + this.dateTime() + '.xlsx');
  }

  private static addRawData(data: any[], wb: XLSX.WorkBook) {
    const keys = Object.keys(data[0]);
    // only save non-null non-object properties
    const finalData = data.map((obj) => this.filterObjectProperties(obj, keys));

    const rawDataSheet = XLSX.utils.json_to_sheet(finalData);
    XLSX.utils.book_append_sheet(wb, rawDataSheet, 'Sheet2');
  }

  private static filterObjectProperties(obj, keys) {
    return keys.reduce((acc, key) => {
      const value = obj[key];
      if (typeof value !== 'object' && value && key != '__typename') {
        return { ...acc, [key]: value };
      } else {
        return acc;
      }
    }, {});
  }

  static dataToRows(
    data,
    selectedColumns,
    aggregatedColumns,
  ): Array<Array<any>> {
    const rows = data.map((dataRow) =>
      selectedColumns
        .map((mapping) => {
          let res = dataRow[mapping.property];

          if (!res && mapping.property.includes('_accessObject_')) {
            // dig down into specified object(s)
            res = mapping.property
              .split('_accessObject_')
              .reduce((j, k) => j && j[k], dataRow);
          }

          return res;
        })
        .concat(aggregatedColumns.map((aColumn) => dataRow[aColumn.property])),
    );
    const headers = selectedColumns
      .map((mapping) => mapping.heading)
      .concat(aggregatedColumns.map((aColumn) => aColumn.heading));

    rows.unshift(headers);
    return rows;
  }

  static dateTime() {
    const d = new Date();
    const currentDateTime =
      d.getFullYear() +
      '-' +
      this.datePad(d.getMonth() + 1) +
      '-' + // getMonth() returns 0-11
      this.datePad(d.getDate()) +
      '-' +
      this.datePad(d.getHours()) +
      this.datePad(d.getMinutes()) +
      this.timeZone(d);

    return currentDateTime; // e.g. '2020-02-12-1451+0200'
  }

  static datePad(n: number) {
    return (Math.abs(n) < 10 ? '0' : '') + n;
  }

  static timeZone(date: Date) {
    const zoneSign = date.getTimezoneOffset() < 0 ? '+' : '-';
    return (
      zoneSign + this.datePad(Math.abs(date.getTimezoneOffset()) / 60) + '00'
    );
  }
}
